import React from 'react';
import t from 'modules/i18n/intl';
import Form, { FormHeader } from '@atlaskit/form';
import { LoadingButton } from '@atlaskit/button';

import { styled } from 'styled-components';
import { Dimensions } from '../../../components/visuals';
import { FirstName, LastName, Phone } from './ContactFields';
import { fetchExternal } from '../duck/actions/contact';
import { useDispatch } from 'react-redux';

const StyledSubmitButton = styled(LoadingButton)`
  margin-top: ${Dimensions.unit}px;
`;

export interface BillingContactFormProps {
  displayName: string;
  email: string;
  firstName: string;
  lastName: string;
  phone: string;
  isRuByRestricted?: boolean;
}

export const BillingContactForm: React.FC<BillingContactFormProps> = (
  props: BillingContactFormProps,
) => {
  const dispatch = useDispatch();
  return (
    <Form
      onSubmit={(data) => {
        const contactDetailsData = { contactDetails: { ...data, email: props.email } };
        dispatch(fetchExternal(contactDetailsData));
      }}
    >
      {({ formProps, submitting }) => (
        <form {...formProps} data-cy="mac-billing-contact-form">
          <FormHeader title={t('mac.edit-details.contact.title')} />
          <FirstName {...props} />
          <LastName {...props} />
          <Phone {...props} />
          <StyledSubmitButton
            type="submit"
            appearance="primary"
            isLoading={submitting}
            isDisabled={submitting || props.isRuByRestricted}
            interactionName="checkout-contacts-submit"
          >
            {t('mac.edit-details.contact.submit')}
          </StyledSubmitButton>
        </form>
      )}
    </Form>
  );
};
